import React, {Component} from 'react'
import Pagination from '../components/Pagination'
import Dropdown from '../components/Dropdown'

class ThumbsBlock extends Component {
    render() {
        let pagination = this.props.pagination ?
            (<Pagination {...this.props.pagination} />) :
            null
        let dropdown = this.props.dropdown ?
            (<Dropdown {...this.props.dropdown} />) :
            null
        let right = this.props.right || null
        let thumbs = this.props.thumbs.data.map((thumb) => {
            return React.createElement(this.props.thumb, {...thumb, key: thumb.id, backpage: this.props.backpage})
        })
        let headline = this.props.title ?
            <div className="headline"><h2>{this.props.title}</h2>
                <i className="line"/>{dropdown}{right}
                <b className="line"/>
            </div> : null;

        return (
            <div>
                {headline}
                <div className="row">
                    {thumbs}
                </div>
                {pagination}
            </div>
        )
    }
}

export default ThumbsBlock


// WEBPACK FOOTER //
// components/ThumbsBlock.js